const pass = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback();
  }
};
export const warehouseOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  menuWidth: "300",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "前仓名称",
      prop: "warehouseName",
      type: "input",
      search: true,
      addVisdiplay: true,
      editVisdiplay: true,
    },
    {
      label: "关联店铺",
      prop: "shopName",
      formsolt: true,
      search: true,
      addVisdiplay: true,
      editVisdiplay: true,
      rules: [
        {
          required: true,
          trigger: "change",
          message: "请选择店铺",
        },
      ],
    },
    {
      label: "标记位置",
      prop: "provinces",
      hide: true,
      formsolt: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "前仓地址",
      prop: "address",
      overHidden: true,
      type: "input",
      width: "380",
      formsolt: true,
      search: true,
      addVisdiplay: true,
      editVisdiplay: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: pass,
        },
      ],
    },
    
    {
      label: "联系电话",
      prop: "warehouseMobile",
      type: "input",
      search: true,
      addVisdiplay: false,
      editVisdiplay: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
